module.exports = __webpack_public_path__ + "static/img/LeadtedStartSmartLarge.b95a510.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gifs/LeadtedStartSmartLarge.gif
// module id = aG6V
// module chunks = 1